import MainLayout from '../layouts/main';
import StoreContainer from './container';
import FeatureTab from './feature-tab';
import TypeTab from './type-tab';
import PeriodTab from './number-tab';
import Search from './search';

function StorePage() {
  return (
    <MainLayout title={STORE_PAGE_TITLE}>
      <div className='mx-6 select-none'>
        <TypeTab />
        <FeatureTab />
        <PeriodTab />
        <Search />
      </div>
      <StoreContainer />
    </MainLayout>
  );
}

export const STORE_PAGE_TITLE = 'فروشگاه';

export default StorePage;
